import React from 'react';
import FilterScroller from './FilterScroller';

/** One selectable category bar, shared by the received notification views. */
export default function NotificationTypeFilter({ options, value, onChange }) {
    return <div className="nc-type-filter" role="group" aria-label="Notification type">
        <span className="nc-filter-label">Type</span>
        <FilterScroller role="group" ariaLabel="Notification types">
            {[['All', 'All types'], ...options].map(([key, label]) =>
                <button key={key} type="button" className="nc-type-option" aria-pressed={value === key}
                    onClick={() => onChange(key)}>{label}</button>)}
        </FilterScroller>
    </div>;
}
